import { render, staticRenderFns } from "./BaseAdminContentView.vue?vue&type=template&id=f05a4550&scoped=true&"
import script from "./BaseAdminContentView.vue?vue&type=script&lang=js&"
export * from "./BaseAdminContentView.vue?vue&type=script&lang=js&"
import style0 from "./BaseAdminContentView.vue?vue&type=style&index=0&id=f05a4550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a4550",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f05a4550')) {
      api.createRecord('f05a4550', component.options)
    } else {
      api.reload('f05a4550', component.options)
    }
    module.hot.accept("./BaseAdminContentView.vue?vue&type=template&id=f05a4550&scoped=true&", function () {
      api.rerender('f05a4550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/BaseAdminContentView.vue"
export default component.exports